// src/sectors/pilates/sessions/components/SessionDetailDialog/SessionHeroCard.jsx
import React from 'react';
import Divider from '@mui/material/Divider';
import Icon from '@mui/material/Icon';
import { alpha, useTheme as useMuiTheme } from '@mui/material/styles';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

import { SoftCard, MiniTag, PillButton } from './SessionDetailAtoms';
import { TR, upper, hm, pickActivity, pickTrainer } from './sessionDetail.utils';

export function SessionHeroCard({
  s,
  loading,
  isPaid, // artık kullanılmıyor ama prop kırılmasın diye tutuyoruz
  isPackage, // artık kullanılmıyor
  booked,
  cap,
  borderSoft,
  onAttendanceClick,
}) {
  const theme = useMuiTheme();
  const isDark = theme.palette.mode === 'dark';

  if (!s) return null;

  const statusTone = upper(s.status) === 'CANCELLED' ? 'red' : 'mint';
  const statusLabel = TR.status(s.status);

  return (
    <SoftCard
      tone="blue"
      sx={(t) => ({
        position: 'relative',
        background: t.palette.mode === 'dark' ? alpha('#fff', 0.04) : alpha('#fff', 0.92),
      })}
    >
      {/* TOP: başlık + meta */}
      <MDBox sx={{ display: 'grid', gap: 0.35 }}>
        <MDTypography variant="button" sx={{ fontWeight: 1000, lineHeight: 1.2 }} noWrap>
          {pickActivity(s)}
          <MDTypography
            component="span"
            variant="caption"
            sx={{ ml: 0.7, opacity: 0.72, fontWeight: 900 }}
          >
            {Number(s.durationMin ?? 0) || 0} dk
          </MDTypography>
        </MDTypography>

        <MDTypography variant="caption" sx={{ opacity: 0.78, fontWeight: 900 }} noWrap>
          <MDTypography component="span" variant="caption" sx={{ opacity: 0.68, fontWeight: 800 }}>
            • Eğitmen: {pickTrainer(s)}
            {loading ? ' • yükleniyor…' : ''}
          </MDTypography>
        </MDTypography>

        {/* SADE: sadece 2 mini tag */}
        <MDBox sx={{ display: 'flex', gap: 0.55, flexWrap: 'wrap', mt: 0.35 }}>
          <MiniTag tone="mint" icon="groups" label={`Kontenjan: ${booked}/${cap || '—'}`} />
        </MDBox>
      </MDBox>

      <Divider sx={{ my: 1 }} />

      {/* ACTION: Yoklama */}
      <PillButton
        icon="fact_check"
        title="Yoklama"
        sub="Geçmişi gör • yoklama gir"
        tone="mint"
        onClick={onAttendanceClick}
        right={
          <MDBox
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.5,
              px: 0.9,
              py: 0.45,
              borderRadius: '999px',
              border: borderSoft,
              bgcolor: isDark ? alpha('#fff', 0.03) : alpha('#0b1220', 0.03),
            }}
          >
            <Icon sx={{ fontSize: 18, opacity: 0.75 }}>groups</Icon>
            <MDTypography variant="caption" sx={{ fontWeight: 1000, opacity: 0.8 }}>
              {booked}
            </MDTypography>
          </MDBox>
        }
      />
    </SoftCard>
  );
}
